import React, { Component } from 'react';
import { Spin, Button, InputNumber, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import format from '../../shared/format';
import SideNav from '../SideNav';
import '../style.less';

class CostOfContractSplit extends Component {
    state = {
        data: {},
        canEdit: false,
        fatalError: false,
    }

    componentDidMount() {
        this.loadData();
        this.queryInvestigationStageByInvId();
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.proContract.queryInvestigationJdeSeparateInvId,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    data,
                    loading: false,
                    fatalError: false,
                });
            },
            errorResult: () => {
                this.setState({
                    loading: false,
                    fatalError: true,
                });
            },
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getNumber = (value) => {
        var number = parseFloat(value);
        return (number && ((number !== number || 0 ) || number)) || 0;
    }

    handleNumberChange = (value, key) => {
        const { data } = this.state;
        data[key] = value;
        const { ssuAmount, siteCloseAmount, dataCleanAmount, caseNumberAmount, lengthAmount } = data;
        if (key === 'ssuAmount' || key === 'siteCloseAmount' || key === 'dataCleanAmount') {
            data.singleTaskAmount = (this.getNumber(ssuAmount) + this.getNumber(siteCloseAmount) + this.getNumber(dataCleanAmount)).toFixed(2);
        }
        data.convertAmount = (this.getNumber(caseNumberAmount) + this.getNumber(lengthAmount) + this.getNumber(data.singleTaskAmount)).toFixed(2);
        this.setState({ data });
    }

    submit = () => {
        const { data } = this.state;
        const { caseNumberAmount, lengthAmount, ssuAmount, siteCloseAmount, dataCleanAmount } = data;
        if (!caseNumberAmount && caseNumberAmount !== 0) {
            message.warning('请输入合同费用中与例数相关的费用/人民币！');
            return;
        } else if (!lengthAmount && lengthAmount !== 0) {
            message.warning('请输入合同费用中与时长相关的费用/人民币！');
            return;
        } else if (!ssuAmount && ssuAmount !== 0) {
            message.warning('请输入SSU/立项及启动准备相关费用/人民币！');
            return;
        } else if (!siteCloseAmount && siteCloseAmount !== 0) {
            message.warning('请输入中心关闭费用/人民币！');
            return;
        } else if (!dataCleanAmount && dataCleanAmount !== 0) {
            message.warning('请输入数据清理锁库费用/人民币！');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.proContract.saveInvestigationJdeSeparateInvId,
            data,
            dataType: 'json',
            doneResult: res => {
                const { success } = res;
                message.success(success);
                this.setState({ loading: true }, () => {
                    this.switchEditStatus(false);
                })
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    cancel = () => {
        this.setState({ canEdit: false });
    }

    switchEditStatus = (canEdit) => {
        this.setState({ canEdit }, () => {
            !canEdit && this.loadData();
        });
    }

    shouleShowUnit = (contract) => {
        const value = format('money', contract);
        return value ? `${value} 元` : '';
    }

    getContent = (key) => {
        const { data, canEdit } = this.state;
        const value = data[key];
        return (
            canEdit ?
                <InputNumber
                    maxLength="17"
                    precision={2}
                    min={0}
                    max={99999999999}
                    style={{ width: '90%' }}
                    value={value}
                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                    onChange={value => this.handleNumberChange(value, key)}
                />
            :
                <div style={{ width: '90%', display: 'inline-block' }}>
                    {format('money', value)}
                </div>
        );
    }

    render() {
        const { data, canEdit, loading, fatalError } = this.state;
        const {
            investigationJdeContractCode,
            investigationName,
            investigationCode,
            jdeContractAmount,
            actualExpenseFee,
            actualFee,
            taxationFee,
            singleTaskAmount,
            convertAmount,
        } = data;
        const { curRole } = sessionStorage;
        const asterisk = <span style={{ color: canEdit ? '#F00' : '#f6f6f6' }}>*</span>;
        return (
            <div className="content">
                <SideNav selectKey='costOfContractSplit' />
                <div className="main costOfContractSplit">
                    <Spin spinning={loading}>
                        <h3 style={{ fontWeight: 'bold' }}>合同费用拆分</h3>
                        <div className="modal-content" style={{ padding: '0 20px' }}>
                            <ul className="modal-list">
                                <li className="modal-item">
                                    <div className="item-left">JDE主项目号:</div>
                                    <div className="item-right">
                                        {investigationJdeContractCode}
                                    </div>
                                </li>
                                <li className="modal-item">
                                    <div className="item-left">项目简称:</div>
                                    <div className="item-right">
                                        {investigationName}
                                    </div>
                                </li>
                                <li className="modal-item">
                                    <div className="item-left">项目编号:</div>
                                    <div className="item-right">
                                        {investigationCode}
                                    </div>
                                </li>
                                <li className="modal-item">
                                    <div className="item-left">合同额含税/人民币:</div>
                                    <div className="item-right">
                                        {this.shouleShowUnit(jdeContractAmount)}
                                    </div>
                                </li>
                                <li className="modal-item">
                                    <div className="item-left">实报实销(不含税)/人民币:</div>
                                    <div className="item-right">
                                        {this.shouleShowUnit(actualExpenseFee)}
                                    </div>
                                </li>
                                <li className="modal-item">
                                    <div className="item-left">实报实销税费/人民币:</div>
                                    <div className="item-right">
                                        {this.shouleShowUnit(actualFee)}
                                    </div>
                                </li>
                                <li className="modal-item">
                                    <div className="item-left">合同额税费/人民币:</div>
                                    <div className="item-right">
                                        {this.shouleShowUnit(taxationFee)}
                                    </div>
                                </li>
                            </ul>
                            <table className="distribute">
                                <tbody>
                                    <tr>
                                        <td className="distribute_td_left bg">{asterisk}合同费用中与例数相关的费用/人民币</td>
                                        <td className="distribute_td_right">
                                            { this.getContent('caseNumberAmount') } 元
                                        </td>
                                        <td className="distribute_td_left"></td>
                                        <td className="distribute_td_right"></td>
                                    </tr>
                                    <tr>
                                        <td className="distribute_td_left bg">{asterisk}合同费用中与时长相关的费用/人民币</td>
                                        <td className="distribute_td_right">
                                            { this.getContent('lengthAmount') } 元
                                        </td>
                                        <td className="distribute_td_left"></td>
                                        <td className="distribute_td_right"></td>
                                    </tr>
                                    <tr>
                                        <td className="distribute_td_left bg" rowSpan="3">合同费用中与单任务相关的费用/人民币</td>
                                        <td className="distribute_td_right" rowSpan="3">
                                            <div style={{ width: '90%', display: 'inline-block' }}>
                                                {format('money', singleTaskAmount)}
                                            </div> 元
                                        </td>
                                        <td className="distribute_td_left bg">{asterisk}SSU/立项及启动准备相关费用/人民币</td>
                                        <td className="distribute_td_right">
                                            { this.getContent('ssuAmount') } 元
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="distribute_td_left bg">{asterisk}中心关闭费用/人民币</td>
                                        <td className="distribute_td_right">
                                            { this.getContent('siteCloseAmount') } 元
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="distribute_td_left bg">{asterisk}数据清理锁库费用/人民币</td>
                                        <td className="distribute_td_right">
                                            { this.getContent('dataCleanAmount') } 元
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="distribute_td_left bg">可折算收入的费用/人民币</td>
                                        <td className="distribute_td_right">
                                            <div style={{ width: '90%', display: 'inline-block' }}>
                                                {format('money', convertAmount)}
                                            </div> 元
                                        </td>
                                        <td className="distribute_td_left"></td>
                                        <td className="distribute_td_right"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {
                            curRole === 'PM' &&
                            (
                                canEdit ?
                                    <div style={{ margin: 20, textAlign: 'center' }}>
                                        <Button type="primary" onClick={this.submit}>保存</Button>
                                        <Button type="ghost" style={{ marginLeft: 10 }} onClick={() => this.switchEditStatus(false)}>取消</Button>
                                    </div>
                                :
                                    <div style={{ margin: 20, textAlign: 'center' }}>
                                        {
                                            fatalError ?
                                                <Button type="primary" disabled={true}>编辑</Button>
                                            :
                                                <Button type="primary" onClick={() => this.canEditByInvStatus(() => this.switchEditStatus(true))}>编辑</Button>
                                        }
                                    </div>
                            )
                        }
                    </Spin>
                </div>
            </div>
        );
    }
}

export default CostOfContractSplit;


// WEBPACK FOOTER //
// ./src/components/projectContract/costOfContractSplit/index.js